import { SVGProps } from 'react';
import { getReferenceTypeSvgStyle } from '../utils';
import { ArrowType, LineType } from '@ardoq/api-types';

type ViewProps = {
  lineBeginning?: ArrowType;
  lineEnding?: ArrowType;
  color: string;
  line: LineType;
  width?: number;
  height?: number;
  pathWidth?: number;
};
export const ReferenceTypePreview = ({
  lineBeginning,
  lineEnding,
  width = 100,
  height = 30,
  pathWidth = 40,
  line,
  color,
}: ViewProps) => {
  const svgStyle = getReferenceTypeSvgStyle(line, color);
  const svgStyles: Record<string, string> = {};
  svgStyle
    .split(';')
    .map(styleElement => styleElement.split(':'))
    .forEach(([key, value]) => {
      svgStyles[key] = value && value.trim();
    });

  const pathAttrs: SVGProps<SVGPathElement> = {
    d: `M 0 10 L ${pathWidth} 10`,
    fill: 'none',
    strokeWidth: '1',
    stroke: svgStyles.stroke,
    strokeDasharray: svgStyles['stroke-dasharray'],
  };

  if (lineBeginning) {
    pathAttrs.markerStart = `url(#${lineBeginning})`;
  }
  if (lineEnding) {
    pathAttrs.markerEnd = `url(#${lineEnding})`;
  }

  return (
    <svg
      width={String(width)}
      height={String(height)}
      viewBox={`0 0 ${pathWidth} 20`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path {...pathAttrs} />
    </svg>
  );
};
